import { getCurrentBusinessId } from './AuthTokenManager';

const initialState: MBAppStateReducer = {
  isHidden: false,
  viewportHeight: 0,
  viewportWidth: 0,
  currentBusinessId: getCurrentBusinessId(),
  currentUserId: undefined,
};

export function appStateReducer(state = initialState, action: AppStateAction) {
  switch (action.type) {
    case 'VIEWPORT_DIMENSION_CHANGE': {
      const { viewportWidth, viewportHeight } = action.value;
      if (viewportWidth === state.viewportWidth && viewportHeight === state.viewportHeight) {
        return state;
      }
      return {
        ...state,
        viewportHeight,
        viewportWidth,
      };
    }

    case 'VISIBILITY_CHANGE': {
      const { isHidden } = action.value;
      return { ...state, isHidden };
    }

    case 'UPDATE_CURRENT_BUSINESS_ID': {
      const { businessId } = action.value;
      return { ...state, currentBusinessId: businessId };
    }

    case 'SET_USER_ID': {
      const { id } = action.value;
      return { ...state, currentUserId: id };
    }

    default:
      return state;
  }
}
